import script from "./AppSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSetting.vue?vue&type=script&lang=ts&setup=true"

import "./AppSetting.vue?vue&type=style&index=0&id=17ec0b70&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/posuto/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ec0b70"]])

export default __exports__